import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import TosModal from './TosModal';
import PrivacyModal from './PrivacyModal';
import './ConsentBanner.css';

const ConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTos, setShowTos] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    const hasConsented = localStorage.getItem('shocz_legal_consent');
    if (!hasConsented) {
      // Delay slightly for better UX
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('shocz_legal_consent', 'true');
    setIsVisible(false);
  };

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.div 
            className="consent-banner-wrapper"
            initial={{ y: 100, x: '-50%', opacity: 0 }}
            animate={{ y: 0, x: '-50%', opacity: 1 }}
            exit={{ y: 100, x: '-50%', opacity: 0 }}
            transition={{ type: 'spring', damping: 25, stiffness: 200 }}
          >
            <div className="consent-banner-content">
              <div className="consent-left">
                <div className="consent-icon">
                  <ShieldCheck size={20} />
                </div>
                <p>
                  By using this site, you agree to our <button className="inline-link" onClick={() => setShowTos(true)}>Terms of Service</button> and <button className="inline-link" onClick={() => setShowPrivacy(true)}>Privacy Policy</button>.
                </p>
              </div>
              <div className="consent-right">
                <button className="accept-consent-btn" onClick={handleAccept}>
                  I Agree
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {showTos && <TosModal onClose={() => setShowTos(false)} />}
      {showPrivacy && <PrivacyModal onClose={() => setShowPrivacy(false)} />}
    </>
  );
};

export default ConsentBanner;
